/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeInterventionTechniqueDto } from '../models/type-intervention-technique-dto';


/**
 * Fonctions de gestion des types d'interventions techniques
 */
@Injectable({
  providedIn: 'root',
})
export class TypesInterventionsTechniquesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeInterventionTechniqueGetList
   */
  static readonly TypeInterventionTechniqueGetListPath = '/api/types-interventions-techniques/list';

  /**
   * Renvoie la liste des types d'interventions techniques.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeInterventionTechniqueGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeInterventionTechniqueGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeInterventionTechniqueDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesInterventionsTechniquesService.TypeInterventionTechniqueGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeInterventionTechniqueDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'interventions techniques.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeInterventionTechniqueGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeInterventionTechniqueGetList(params?: {
  }): Observable<Array<TypeInterventionTechniqueDto>> {

    return this.typeInterventionTechniqueGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeInterventionTechniqueDto>>) => r.body as Array<TypeInterventionTechniqueDto>)
    );
  }

  /**
   * Path part for operation typeInterventionTechniqueLoadList
   */
  static readonly TypeInterventionTechniqueLoadListPath = '/api/types-interventions-techniques/load-list';

  /**
   * Renvoie la liste des types d'interventions techniques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeInterventionTechniqueLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeInterventionTechniqueLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesInterventionsTechniquesService.TypeInterventionTechniqueLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'interventions techniques (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeInterventionTechniqueLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeInterventionTechniqueLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeInterventionTechniqueLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeInterventionTechniqueGet
   */
  static readonly TypeInterventionTechniqueGetPath = '/api/types-interventions-techniques/{id}';

  /**
   * Renvoie le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeInterventionTechniqueGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeInterventionTechniqueGet$Response(params: {

    /**
     * Identifiant du type d&#x27;intervention technique
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeInterventionTechniqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesInterventionsTechniquesService.TypeInterventionTechniqueGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeInterventionTechniqueDto>;
      })
    );
  }

  /**
   * Renvoie le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeInterventionTechniqueGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeInterventionTechniqueGet(params: {

    /**
     * Identifiant du type d&#x27;intervention technique
     */
    id: number;
  }): Observable<TypeInterventionTechniqueDto> {

    return this.typeInterventionTechniqueGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeInterventionTechniqueDto>) => r.body as TypeInterventionTechniqueDto)
    );
  }

  /**
   * Path part for operation typeInterventionTechniquePut
   */
  static readonly TypeInterventionTechniquePutPath = '/api/types-interventions-techniques/{id}';

  /**
   * Met à jour le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeInterventionTechniquePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeInterventionTechniquePut$Response(params: {

    /**
     * Identifiant du type d&#x27;intervention technique à mettre à jour
     */
    id: number;

    /**
     * Type d'intervention technique
     */
    body: TypeInterventionTechniqueDto
  }): Observable<StrictHttpResponse<TypeInterventionTechniqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesInterventionsTechniquesService.TypeInterventionTechniquePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeInterventionTechniqueDto>;
      })
    );
  }

  /**
   * Met à jour le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeInterventionTechniquePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeInterventionTechniquePut(params: {

    /**
     * Identifiant du type d&#x27;intervention technique à mettre à jour
     */
    id: number;

    /**
     * Type d'intervention technique
     */
    body: TypeInterventionTechniqueDto
  }): Observable<TypeInterventionTechniqueDto> {

    return this.typeInterventionTechniquePut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeInterventionTechniqueDto>) => r.body as TypeInterventionTechniqueDto)
    );
  }

  /**
   * Path part for operation typeInterventionTechniqueDelete
   */
  static readonly TypeInterventionTechniqueDeletePath = '/api/types-interventions-techniques/{id}';

  /**
   * Supprime le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeInterventionTechniqueDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeInterventionTechniqueDelete$Response(params: {

    /**
     * Identifiant du type d&#x27;intervention technique à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesInterventionsTechniquesService.TypeInterventionTechniqueDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeInterventionTechniqueDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeInterventionTechniqueDelete(params: {

    /**
     * Identifiant du type d&#x27;intervention technique à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeInterventionTechniqueDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeInterventionTechniquePost
   */
  static readonly TypeInterventionTechniquePostPath = '/api/types-interventions-techniques';

  /**
   * Crée le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeInterventionTechniquePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeInterventionTechniquePost$Response(params: {

    /**
     * Type d'intervention technique
     */
    body: TypeInterventionTechniqueDto
  }): Observable<StrictHttpResponse<TypeInterventionTechniqueDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesInterventionsTechniquesService.TypeInterventionTechniquePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeInterventionTechniqueDto>;
      })
    );
  }

  /**
   * Crée le type d'intervention technique spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeInterventionTechniquePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeInterventionTechniquePost(params: {

    /**
     * Type d'intervention technique
     */
    body: TypeInterventionTechniqueDto
  }): Observable<TypeInterventionTechniqueDto> {

    return this.typeInterventionTechniquePost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeInterventionTechniqueDto>) => r.body as TypeInterventionTechniqueDto)
    );
  }

}
